import { render, staticRenderFns } from "./shoppingGuideTask.vue?vue&type=template&id=0681080c&scoped=true"
import script from "./shoppingGuideTask.vue?vue&type=script&lang=js"
export * from "./shoppingGuideTask.vue?vue&type=script&lang=js"
import style0 from "./shoppingGuideTask.vue?vue&type=style&index=0&id=0681080c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0681080c",
  null
  
)

export default component.exports